import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './buysell.css';
import { getFirestore, collection, query, where, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollection } from 'react-firebase-hooks/firestore';
import { auth, db } from '../firebase';
import LoginModal from '../auth/LoginModal';  // Import the LoginModal component
import createAd from './createAd';

const MyListings = () => {
  const [user] = useAuthState(auth);
  const [showLoginModal, setShowLoginModal] = useState(!user);
  const navigate = useNavigate();
  
  const adsRef = collection(db, 'ads');
  const q = user ? query(adsRef, where('userId', '==', user.uid), orderBy('createdAt', 'desc')) : null;
  
  const [adsSnapshot, loading, error] = useCollection(q);
  
  console.log("Current user UID:", user ? user.uid : "No user logged in");
  console.log("Ads snapshot:", adsSnapshot);
  console.log("Loading:", loading);
  console.log("Error:", error);

  const handleDelete = async (adId) => {
    if (!user) {
      setShowLoginModal(true);
      return;
    }

    if (window.confirm('Are you sure you want to delete this ad?')) {
      try {
        await deleteDoc(doc(db, 'ads', adId));
        console.log('Ad deleted successfully');
      } catch (error) {
        console.error('Error deleting ad: ', error);
      }
    }
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    // The page will automatically refresh its data due to useAuthState and useCollection hooks
  };

  // If user is not logged in, show login prompt and modal
  if (!user) {
    return (
      <Container className="mt-5">
        <div className="d-flex align-items-center mb-3">
          <Button 
            variant="link" 
            className="back-button p-0 me-3" 
            onClick={() => navigate('/buysell')}
            aria-label="Go back"
          >
            <FaArrowLeft />
          </Button>
          <h2 className="mb-0">My Listings</h2>
        </div>
        <div className="text-center">
          <p>Please log in to view your listings</p>
        </div>
        <LoginModal 
          show={showLoginModal}
          onHide={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      </Container>
    );
  }

  if (loading) {
    return (
      <Container className="mt-5">
        <div className="d-flex align-items-center mb-3">
          <Button 
            variant="link" 
            className="back-button p-0 me-3" 
            onClick={() => navigate('/buysell')}
            aria-label="Go back"
          >
            <FaArrowLeft />
          </Button>
          <h2 className="mb-0">My Listings</h2>
        </div>
        <div>Loading...</div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <div className="d-flex align-items-center mb-3">
          <Button 
            variant="link" 
            className="back-button p-0 me-3" 
            onClick={() => navigate('/buysell')}
            aria-label="Go back"
          >
            <FaArrowLeft />
          </Button>
          <h2 className="mb-0">My Listings</h2>
        </div>
        <div>Error: {error.message}</div>
      </Container>
    );
  }

  const ads = adsSnapshot?.docs.map(doc => ({ id: doc.id, ...doc.data() })) || [];

  return (
    <Container fluid className='p-0'>
      <Row className="m-0">
        <Col className="listings-col">
          <Container fluid>
            <div className="d-flex align-items-center mb-3">
              <Button 
                variant="link" 
                className="back-button p-0 me-3" 
                onClick={() => navigate('/buysell')}
                aria-label="Go back"
              >
                <FaArrowLeft />
              </Button>
              <h2 className="mb-0">My Listings</h2>
            </div>
            <div className="mb-3-button">
              <Button className="createAdButton" as={Link} to="/create-ad" variant="primary">Create New</Button>
            </div>
            {ads.length === 0 ? (
              <p>You have no listings yet.</p>
            ) : (
              <Row>
                {ads.map(ad => (
                  <Col key={ad.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                    <Card>
                      <div style={{ position: 'relative' }}>
                        <Card.Img 
                          variant="top" 
                          src={ad.imageUrls ? ad.imageUrls[0] : ad.imageUrl}
                          className="card-img-top"
                        />
                        {ad.imageUrls && ad.imageUrls.length > 1 && (
                          <Badge bg="secondary" style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            padding: '5px 10px',
                            borderRadius: '50%'
                          }}>
                            {ad.imageUrls.length}
                          </Badge>
                        )}
                      </div>
                      <Card.Body>
                        <Card.Title>{ad.ItemName || 'Untitled Ad'}</Card.Title>
                        <Card.Text>
                          {ad.description ? 
                            (ad.description.length > 100 ? 
                              `${ad.description.substring(0, 100)}...` : 
                              ad.description) : 
                            'No description'}
                        </Card.Text>
                        <Card.Text>
                          <strong>Price:</strong> R{ad.Price ? ad.Price.toLocaleString() : 'Not specified'}
                        </Card.Text>
                        <div className="buttons-container">
                          <span className="action-btn-link">
                            <Button 
                              as={Link} 
                              to={`/edit-ad/${ad.id}`} 
                              variant="primary" 
                              className="action-btn"
                            >
                              Edit
                            </Button>
                          </span>
                          <span className="action-btn-link">
                            <Button 
                              variant="danger" 
                              onClick={() => handleDelete(ad.id)}
                              className="action-btn"
                            >
                              Delete
                            </Button>
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </Container>
        </Col>
      </Row>

      {/* Login Modal */}
      <LoginModal 
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </Container>
  );
};

export default MyListings;